import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './navigationService';

const NavigationProvider = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    return null;
};

export default NavigationProvider;